import { Reservation as ApiReservation } from "../../openapi";

export const getOperatorIdFromReservation = (
  reservation: Reservation | ApiReservation
): string => reservation.operator?.id || reservation.tour.operatorId;
